var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { Job } from 'packages/v3/jobs/Job';
import ENV from 'config/env.js';
import { PipelineStage } from 'packages/v3/pipeline/PipelineStage';
import PathBuilder from 'packages/core/PathBuilder';
import { EntityBuilder } from '@decahedron/entity';
import { Pagination } from 'packages/core/Pagination';
import { Candidate } from 'packages/v3/jobs/Candidate';
var JobRepository = /** @class */ (function (_super) {
    __extends(JobRepository, _super);
    function JobRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_ROOT + "v3/";
        _this.entity = Job;
        _this.url = 'jobs/:id';
        return _this;
    }
    JobRepository.prototype.updateStages = function (id, stages) {
        return __awaiter(this, void 0, Promise, function () {
            var config;
            var _this = this;
            return __generator(this, function (_a) {
                config = { baseURL: this.baseUrl };
                return [2 /*return*/, this.axios.put(PathBuilder("/jobs/" + id + "/stages"), stages.map(function (s) { return s.toJson(); }), config)
                        .then(function (response) {
                        var result = _this.responseTransformer(response);
                        return EntityBuilder.buildMany(PipelineStage, result.data);
                    })];
            });
        });
    };
    JobRepository.prototype.getCandidatesForJob = function (jobId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.get(this.url + "/candidates", { id: "" + jobId }).then(function (response) {
                        var result = _this.responseTransformer(response);
                        return {
                            items: EntityBuilder.buildMany(Candidate, result.data),
                            pagination: EntityBuilder.buildOne(Pagination, result.pagination || result.meta),
                        };
                    })];
            });
        });
    };
    JobRepository.prototype.updateCandidateStage = function (candidate, stage) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = PathBuilder("" + this.baseUrl + this.url + "/candidates/" + candidate.id, { id: "" + candidate.jobId });
                return [2 /*return*/, this.put(url, { pipeline_stage_id: stage.id })];
            });
        });
    };
    JobRepository.prototype.bulkMoveInJob = function (jobId, candidateIds, stageId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = this.baseUrl + "jobs/" + jobId + "/candidates";
                return [2 /*return*/, this.put(url, { candidate_ids: candidateIds, pipeline_stage_id: stageId })];
            });
        });
    };
    JobRepository.prototype.removeCandidatesFromPipeline = function (candidates) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, url;
            return __generator(this, function (_a) {
                payload = {
                    data: {
                        candidate_ids: candidates.map(function (candidate) { return candidate.id; }),
                    },
                };
                url = PathBuilder("" + this.baseUrl + this.url + "/candidates", { id: "" + candidates[0].jobId });
                return [2 /*return*/, this.axios.delete(url, payload)];
            });
        });
    };
    JobRepository.prototype.removeCandidateFromRecruitment = function (email, jobId, formResponseUuid, createdAt) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, url;
            return __generator(this, function (_a) {
                payload = {
                    data: {
                        email: email,
                        response_uuid: formResponseUuid,
                        code: createdAt,
                    },
                };
                url = this.baseUrl + "jobs/" + jobId + "/candidate/unsubscribe";
                return [2 /*return*/, this.axios.delete(url, payload)];
            });
        });
    };
    return JobRepository;
}(AbstractRepository));
export { JobRepository };
